import React from "react";


const IndianSites = () => {
  return (
    <div id="dash-site" style={{padding:'35px 0'}}>
      {/* <div className="t-title">
        <span id="blue">Shop </span>
        <span id="org">From </span>
        <span id="org">Below </span>
        <span id="blue">Sites</span>
      </div>
      <p>
        Utilizing virtual locker addresses in Indian e-commerce enhances
        security and convenience. Customers copy-paste their virtual locker
        address for privacy, protecting personal information. Virtual lockers
        also provide flexibility and real-time tracking, elevating the
        e-commerce experience.
      </p>{" "} */}
      
      <div id="ds3">
        <h1>Shop From Below Sites</h1>
        <div className="work-dia">
          <img
            src="https://raw.githubusercontent.com/KHUNTPRIYANSH/site_photos/main/shipping/work-dia2.png"
            alt=""
          />
        </div>
      </div>
          <div class="client-slider">
              <div class="client-slide-track">
                <div class="client-slide">
                  <img src="../comp/1.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/2.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/3.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/4.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/5.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/6.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/7.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/8.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/9.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/10.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/11.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/12.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/13.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/14.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/15.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/16.png" alt="" />
                </div>
              </div>
            </div>
            <div class="client-slider">
              <div class="client-slide-track">
                <div class="client-slide">
                  <img src="../comp/1.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/2.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/3.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/4.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/5.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/6.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/7.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/8.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/9.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/10.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/11.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/12.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/13.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/14.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/15.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="../comp/16.png" alt="" />
                </div>
              </div>
            </div>
      {/* <div id="gr">.</div> */}
    </div>
  );
};

export default IndianSites;
